import type { SelectProps } from 'core/components/ui/Select';
import { Select } from 'core/components/ui/Select';
import { filterOption } from 'core/utils/filter-option';
import { getTimeZones } from '../../../utils';

const options = getTimeZones();

export function TimeZoneSelect(props: SelectProps) {
  return <Select allowClear filterOption={filterOption} options={options} showSearch {...props} />;
}
